
import Confirm from 'vux/src/components/confirm/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

const week = ['周日','周一','周二','周三','周四','周五','周六'];
const orderSrc = ['','公众号','自助二维码'];

export default {
directives: {
TransferDom
},
components: {
Confirm,
XDialog,
XButton,
Group,
GroupTitle,
Cell
},
created() {
console.log('created...')
this.initOrderInfo()
},
data () {
return {
dialogMsg: '',
showHideOnBlur:false,
shopName: '',
orderDetail: {goodsInfo:{}},
paramShopId: this.$route.params.shopId,
paramOrderNo: this.$router.currentRoute.params.id,
paramVoucherNo: this.$router.currentRoute.params.voucherNo,

consumeOrderData:{

confirm: false, // 默认关闭
confirmMsg: null, // 提示框内内容
refused: '取消核销',
agreed: '确认核销',
checkResult: null, // 审核结果
checkRemark: null, // 审核备注
orderNo: null
}
}
},
methods:{
onCancel () {
console.log('on cancel')
},
onHide () {
console.log('on hide')
},
onShow5 () {
this.$refs.confirm5.setInputValue('')
},
initOrderInfo(){
let shopId = this.paramShopId;
let orderNo = this.paramOrderNo;
let params = {shopId:shopId, orderNo:orderNo, queryType:"ALL"}
let _this = this;
_this.axios.post('/v1/shop/'+shopId+'/order/tuan/GET_ORDER_LIST', params, {
headers: {}
}).then(function (response) {
if (response.data.data != undefined && response.data.data.rows.length > 0) {
_this.orderDetail = response.data.data.rows[0];
} else {
_this.dialogMsg = "订单信息不存在";
_this.showHideOnBlur = true;
}
}).catch(function (response) {
console.log(response);
});
},
consumeOrderEvent(orderNo, type){
this.consumeOrderData.orderNo = orderNo

if (type == 1) {
this.consumeOrderData.checkResult = 'PASS'
this.consumeOrderData.confirmMsg = this.consumeOrderData.agreed
}else{
this.consumeOrderData.checkResult = 'REJECT'
this.consumeOrderData.confirmMsg = this.consumeOrderData.refused
}

this.consumeOrderData.confirm = true
},

onShowConsume(){
this.$refs.confirmConsume.setInputValue(this.consumeOrderData.confirmMsg)
},

onConfirmConsume(value){
let shopId = this.paramShopId
let checkResult = this.consumeOrderData.checkResult
let orderNo = this.consumeOrderData.orderNo
let voucherNo = this.paramVoucherNo
let _this = this
_this.axios.post('/v1/shop/'+shopId+'/order/tuan/CONSUME_ORDER', {'shopId':shopId,'consumeMthod':1,'voucherNo':voucherNo,'orderNo':orderNo}, {
headers: {}
}).then(function (response) {
if (response.data.code != undefined && response.data.code == 0) {
_this.dialogMsg = '操作成功'
_this.showHideOnBlur = true

_this.initOrderInfo()
} else {
_this.dialogMsg = response.data.msg
_this.showHideOnBlur = true
}
}).catch(function (response) {
_this.showHideOnBlur = true;
_this.dialogMsg = response.message;
});
},
formateValidDate(validStartDate, validEndDate) {
if(validStartDate == undefined || validEndDate == undefined) {
return "";
}
let validDate = "";
let d1 = validStartDate;
let d2 = validEndDate;
let date1 = new Date(d1);
let date2 = new Date(d2);
if (date1-date2==0) {
return d1 + "(" + week[date1.getDay()] + ")";
} else {
return d1 + "(" + week[date1.getDay()] + ")  至  " + d2 + "(" + week[date2.getDay()] + ")";
}
},
formateChannelType(saleChannelType){
return orderSrc[saleChannelType];
},
getGoodsUnitPrice(totalPrice, quantity) {
if(totalPrice == undefined) {
return "";
}
return totalPrice/quantity*0.01;
}
}
}



// WEBPACK FOOTER //
// ./src/components/tuan_order/Consumer.vue